module.exports = __webpack_public_path__ + "img/layout-help.1d9be0a0.svg";